import { render } from "./GoogleMain.vue?vue&type=template&id=002400ec"
import script from "./GoogleMain.vue?vue&type=script&lang=js"
export * from "./GoogleMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__